import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon_add.png'


const _withScopeId = n => (_pushScopeId("data-v-582ca022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-select" }
const _hoisted_2 = { class: "user-list" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查询")

export function render(_ctx, _cache) {
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_company_type_select = _resolveComponent("company-type-select")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")
  const _component_array_description = _resolveComponent("array-description")
  const _component_location_description = _resolveComponent("location-description")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["user-content", _ctx.isError ? 'is-error': ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "请选择"))
          : (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              class: "company-name",
              closable: "",
              color: "blue",
              onClose: _withModifiers(_ctx.removeSelected, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.valueName), 1)
              ]),
              _: 1
            }, 8, ["onClose"]))
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args))),
        class: "add-icon"
      }, _hoisted_5)
    ], 2),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = $event => ((_ctx.visible) = $event)),
      centered: true,
      keyboard: false,
      "mask-closable": false,
      title: "选择往来单位",
      width: "1000px",
      onCancel: _ctx.closeModal,
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.queryRef.companyName,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.queryRef.companyName) = $event)),
                  valueModifiers: { trim: true },
                  "allow-clear": "",
                  placeholder: "请输入往来单位名称关键字",
                  style: {"width":"250px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_company_type_select, {
                  value: _ctx.queryRef.cooperationCompanyTypeIds,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => ((_ctx.queryRef.cooperationCompanyTypeIds) = $event)),
                  placeholder: "请选择往来单位类别",
                  width: "300px"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: _ctx.reset,
                  style: {"margin-left":"14px !important"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  loading: _ctx.loading,
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_table_wrapper, {
          dataSource: _ctx.dataSource,
          onOnTableChange: _ctx.onTableChange,
          onOnRadioChange: _ctx.onRadioChange,
          pagination: _ctx.pagination,
          loading: _ctx.loading,
          columns: _ctx.columns,
          showRadiobox: true
        }, {
          cooperationCompanyTypeNames: _withCtx(({ record } ) => [
            _createVNode(_component_array_description, {
              "data-source": record?.cooperationCompanyTypeNames
            }, null, 8, ["data-source"])
          ]),
          location: _withCtx(({ record }) => [
            _createVNode(_component_location_description, { record: record }, null, 8, ["record"])
          ]),
          _: 1
        }, 8, ["dataSource", "onOnTableChange", "onOnRadioChange", "pagination", "loading", "columns"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel", "onOk"])
  ]))
}